import { createAction, props } from '@ngrx/store';

export const emailAdmin = createAction(
  '[Email Admin] Send Email',
  props<{
    username: string;
    adminId: number;
    message: string;
  }>()
);

export const emailAdminSuccess = createAction(
  '[Email Admin] Send Email Success',
  props<{
    adminId: number;
    message: string;
  }>()
);

export const emailAdminFailure = createAction('[Email Admin] Send Email Failure', props<{ error: any }>());
